<template>
	<div class='main-mybody1' id='lookthree'>
		<a-row>
			<a-col :span='24'>
				<div class='look_g'>
					<div></div>聯絡資料
				</div>
				<a-table
				    style="width:100%;"
				    :columns="columns"
				    :data-source="columnsData"
					:rowKey='(record, index) => index'
					:pagination="false"
				    ></a-table>
			</a-col>
		</a-row>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				columns:[
					 // { title: 'D', dataIndex: 'key' },
				    {title: '姓名',dataIndex: 'name',align:'left',width:'20%'},
					{title: '電話',dataIndex: 'phone',align:'center',width:'25%'},
				    {title: '電郵地址',dataIndex: 'email',align:'center',width:'30%'},
				    {title: '國家/地區',dataIndex: 'country_area',align:'right',width:'25%'},
				],
				columnsData:[],
				params: { // 任務數
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					searchstr: '',
					hot_status: '',
					perPage: 10, //每頁條目數
					}
			}
		},
		mounted(){
			this.getdate()
		},
		methods:{
			getdate(){
				// for(let a= 0; a<100;a++){
				// 	this.columnsData.push({
				// 		country_area: "香港特別行政區",
				// 		email: "Alan@qmisgroup.com.cn",
				// 		name: "Alan",
				// 		phone: "43243234"
				// 	})
				// }
				this.$ajax({
					method: 'post',
					url: this.$api.getSuperAdminInfo,
					data: {
						// token: this.$store.state.token,
					}
				}).then(res => {
					if(res.data.qmiscode == 1000){
						this.columnsData = res.data.admininfoList
					}
				})
			}
		}
	}
</script>

<style lang="scss">
	#lookthree{
		.ant-table-tbody > tr > td{
			border-bottom: 0 !important;
		}
		.ant-table-thead > tr:first-child > th:first-child{
			border-bottom: 0 !important;
			font-size: .8rem;
		}
		.ant-table-thead > tr > th{
			border-bottom: 0 !important;
			font-size: .8rem;
		}
	}
</style>
